import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'

const Wishlist = ({isOpen, onClose, product}) => {
    debugger
    if (!isOpen) return null; 

  return (
    <Modal show={isOpen} onHide={onClose}>
    <Modal.Header closeButton>
      <Modal.Title>Wishlist</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div key={product.id}>
        <img src={product.imageUrl} alt={`Product ${product.id}`} />
        <h3>{product.name}</h3>
        <p>{product.description}</p>
          <button className="btn btn-light" >Add to cart</button>
        <p>{product.price}</p>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-light" >Continue Shopping</button>
      <button className="btn btn-dark" >Open wishlist page</button>
    </Modal.Footer>
  </Modal>
  );
}

export default Wishlist